import { NewRfq, Rfqs } from "@/App/Credit"
import { MobileCreditPage } from "@/App/Credit/MobileCredit"
import {
  SectionName,
  useIsTornOut,
} from "@/App/TearOutSection/tearOutSection.state"
import { CreditTrades } from "@/App/Trades"
import { Resizer } from "@/components/Resizer"
import { useIsDesktop } from "@/utils/useIsDesktop"
import { withSubscribe } from "@/utils/withSubscribe"

export const CreditPage = withSubscribe(() => {
  const isDesktop = useIsDesktop()

  const blotterTornOut = useIsTornOut(SectionName.CreditBlotter)
  const newRfqTornOut = useIsTornOut(SectionName.NewRfq)

  if (isDesktop) {
    return (
      <>
        <Resizer defaultHeight={30}>
          <Rfqs />
          {!blotterTornOut && <CreditTrades />}
        </Resizer>
        {!newRfqTornOut && <NewRfq />}
      </>
    )
  }

  return <MobileCreditPage />
})
